var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSec2Icon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sec2Icon1",
    transform: "translate(-480 -878)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_4860",
    "data-name": "\\uC0AC\\uAC01\\uD615 4860",
    width: 50,
    height: 50,
    rx: 12,
    transform: "translate(480 878)",
    fill: "#f2f4f6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "premium-icon-headset-1376208",
    transform: "translate(491 889)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33704",
    "data-name": "\\uD328\\uC2A4 33704",
    d: "M283.64,384.949h-7.979a.447.447,0,0,1,0-.894h7.979a1.613,1.613,0,0,0,1.611-1.611v-3.649a.447.447,0,0,1,.894,0v3.649A2.508,2.508,0,0,1,283.64,384.949Zm0,0",
    transform: "translate(-259.303 -357.075)",
    fill: "#434a5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33705",
    "data-name": "\\uD328\\uC2A4 33705",
    d: "M426.692,227.629h-.973v9.718h.973a2.421,2.421,0,0,0,2.414-2.413v-4.892a2.421,2.421,0,0,0-2.414-2.413Zm0,0",
    transform: "translate(-401.106 -214.867)",
    fill: "#707487"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33706",
    "data-name": "\\uD328\\uC2A4 33706",
    d: "M427.956,227.989a2.393,2.393,0,0,0-1.264-.36h-.973v9.718h.973a2.393,2.393,0,0,0,1.264-.36Zm0,0",
    transform: "translate(-401.105 -214.866)",
    fill: "#52586d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33707",
    "data-name": "\\uD328\\uC2A4 33707",
    d: "M2.413,227.629h.973v9.718H2.413A2.421,2.421,0,0,1,0,234.934v-4.892a2.421,2.421,0,0,1,2.413-2.413Zm0,0",
    transform: "translate(0 -214.867)",
    fill: "#707487"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33708",
    "data-name": "\\uD328\\uC2A4 33708",
    d: "M2.085,234.934v-4.892a2.419,2.419,0,0,1,1.3-2.14v-.274H2.413A2.421,2.421,0,0,0,0,230.042v4.892a2.421,2.421,0,0,0,2.413,2.413h.973v-.274A2.419,2.419,0,0,1,2.085,234.934Zm0,0",
    transform: "translate(0 -214.866)",
    fill: "#52586d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33709",
    "data-name": "\\uD328\\uC2A4 33709",
    d: "M90.594,12.193h1.322V9.4a9.429,9.429,0,0,0-9.4-9.4h-.839a9.429,9.429,0,0,0-9.4,9.4v2.792H73.6V10.917a8.16,8.16,0,0,1,8.136-8.136h.726a8.16,8.16,0,0,1,8.136,8.136Zm0,0",
    transform: "translate(-68.095)",
    fill: "#494e5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33710",
    "data-name": "\\uD328\\uC2A4 33710",
    d: "M83.138.021C82.932.008,82.724,0,82.515,0h-.839a9.429,9.429,0,0,0-9.4,9.4v2.792H73.6V10.917a8.067,8.067,0,0,1,1.136-4.133,9.446,9.446,0,0,1,8.4-6.762Zm0,0",
    transform: "translate(-68.095 0)",
    fill: "#4c546f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33711",
    "data-name": "\\uD328\\uC2A4 33711",
    d: "M240.936,459.147a1.573,1.573,0,1,1-1.573-1.573A1.573,1.573,0,0,1,240.936,459.147Zm0,0",
    transform: "translate(-224.041 -431.721)",
    fill: "#707487"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33712",
    "data-name": "\\uD328\\uC2A4 33712",
    d: "M239.874,459.147a1.569,1.569,0,0,1,.531-1.178,1.573,1.573,0,1,0,0,2.356A1.57,1.57,0,0,1,239.874,459.147Zm0,0",
    transform: "translate(-224.042 -431.721)",
    fill: "#52586d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33713",
    "data-name": "\\uD328\\uC2A4 33713",
    d: "M375.737,205.746h-1.619a.8.8,0,0,0-.795.795V217.2a.8.8,0,0,0,.795.794h1.619a.8.8,0,0,0,.794-.794v-10.66A.8.8,0,0,0,375.737,205.746Zm0,0",
    transform: "translate(-351.74 -194.263)",
    fill: "#707487"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33714",
    "data-name": "\\uD328\\uC2A4 33714",
    d: "M375.409,217.2v-10.66a.8.8,0,0,1,.562-.759.8.8,0,0,0-.233-.035h-1.619a.8.8,0,0,0-.794.795V217.2a.8.8,0,0,0,.794.795h1.619a.787.787,0,0,0,.233-.035.8.8,0,0,1-.562-.759Zm0,0",
    transform: "translate(-351.74 -194.267)",
    fill: "#52586d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33715",
    "data-name": "\\uD328\\uC2A4 33715",
    d: "M56.279,205.746H57.9a.8.8,0,0,1,.795.795V217.2a.8.8,0,0,1-.795.794H56.279a.8.8,0,0,1-.795-.794v-10.66A.8.8,0,0,1,56.279,205.746Zm0,0",
    transform: "translate(-52.277 -194.263)",
    fill: "#707487"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33716",
    "data-name": "\\uD328\\uC2A4 33716",
    d: "M57.569,217.2v-10.66a.8.8,0,0,1,.561-.759.793.793,0,0,0-.233-.035H56.279a.8.8,0,0,0-.795.795V217.2a.8.8,0,0,0,.795.795H57.9a.786.786,0,0,0,.233-.035.8.8,0,0,1-.561-.759Zm0,0",
    transform: "translate(-52.277 -194.267)",
    fill: "#52586d"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec2Icon1);
export default __webpack_public_path__ + "static/media/sec2Icon1.cbda9fe59b5b1cf9356f2ae7ba5dbcd3.svg";
export { ForwardRef as ReactComponent };